<form class="form form--classification" [formGroup]="formGroup">
  <div class="col scrollbar">
    <div class="classification-popup-outer">
      <div class="classification-popup-outer__left">
        <div class="classification-configuration">
          <h3>{{ id ? 'Update' : 'Add' }} Classification</h3>
          <div class="form__group">
            <label class="form__label">Classification</label>
            <ng-container *ngIf="!id">
              <p-select
                class="form__dropdown select-box"
                formControlName="crmClassificationType"
                placeholder="Select Classification"
                [options]="classificationTypeOptions"
                optionLabel="wipStatesName"
                optionValue="wipStatesName"
                appendTo="body"
                filter="true"
              >
              </p-select>
              <div *ngIf="f.crmClassificationType.errors && f.crmClassificationType.touched" class="invalid-feedback">Classification is required</div>
            </ng-container>

            <input *ngIf="id" class="form__control" readonly value="{{ f.crmClassificationType.value }}" />
          </div>

          <div class="form__group">
            <label class="form__label">Display Name</label>
            <input type="text" formControlName="crmClassificationDisplayName" class="form__control" pInputText />
            <div *ngIf="f.crmClassificationDisplayName.errors && f.crmClassificationDisplayName.touched" class="invalid-feedback">Display name is required</div>
          </div>

          <div class="form__group">
            <label class="form__label">WIP States</label>
            <p-select
              class="form__dropdown select-box"
              formControlName="crmWIPStatusNameBT"
              placeholder="Select WIP States"
              [options]="brightreeStatusOptions"
              optionLabel="wipStatesName"
              optionValue="wipStatesName"
              appendTo="body"
              filter="true"
            >
            </p-select>
            <div *ngIf="f.crmWIPStatusNameBT.errors && f.crmWIPStatusNameBT.touched" class="invalid-feedback">Brightree Status is required</div>
          </div>

          <div class="form__group">
            <label class="form__label">WIP Assigned To</label>
            <p-select
              class="form__dropdown select-box"
              placeholder="Select WIP Assigned To"
              formControlName="crmWIPAssignedToKey"
              [options]="wipAssignedToOptions"
              optionLabel="wipStatesName"
              optionValue="wipStatesId"
              appendTo="body"
              filter="true"
            >
            </p-select>
          </div>

          <div class="form__group">
            <label class="form__label">Inventory Location</label>
            <p-select
              class="form__dropdown select-box"
              placeholder="Select Inventory Location"
              formControlName="crmInvetoryLocationId"
              [options]="InvetoryLocationOptions"
              optionLabel="invetoryLocationName"
              optionValue="invetoryLocationId"
              appendTo="body"
              filter="true"
            >
            </p-select>
          </div>

          <div class="form__group">
            <label class="form__label">Map Therapist(s)</label>
            <p-multiSelect
              class="form__multiSelect select-box"
              panelStyleClass="branch-zindex"
              formControlName="therapistIds"
              placeholder="Select Therapist(s)"
              selectedItemsLabel="{0} Therapists Selected"
              [filter]="true"
              appendTo="body"
              [options]="therapists"
            >
            </p-multiSelect>
          </div>

          <div class="form__group desription-box status-checkbox" *ngIf="showUpdatePODStatus">
            <span class="form__checkbox-outer">
              <p-checkbox [binary]="true" class="form__checkbox"
              formControlName="isUpdatePOD"
              label="Update POD Status" inputId="isUpdatePOD"></p-checkbox>
              <label class="checkbox-text" for="isUpdatePOD">Update POD Status</label>
            </span>
          </div>
          <div class="form__group desription-box status-checkbox">
            <span class="form__checkbox-outer">
              <p-checkbox [binary]="true" class="form__checkbox" 
              formControlName="crmIsEnableAppointmentMaxLimit" 
              label="Allow Maximum Appt. Limit" (onChange)="onAllowedmaxAppointment()" inputId="allowMaxApptLimit"></p-checkbox>
              <label class="checkbox-text" for="allowMaxApptLimit">Allow Maximum Appt. Limit</label>
            </span>
          </div>
          <div class="form__group desription-box">
            <small>This is the maximum number of appts. to be booked on particular appointment date.</small>
          </div>
          <div class="full-width">
            <div class="form__group">
              <label class="form__label">No. of Appt. Per Day</label>
              <input type="number" formControlName="crmMaxNoOfAppointment" class="form__control" pInputText />
              <div *ngIf="f.crmMaxNoOfAppointment.errors && f.crmMaxNoOfAppointment.touched" class="invalid-feedback" style="bottom: inherit !important; top: 71px">
                No. of Appointment is required
              </div>
            </div>
          </div>
        </div>

        <div class="duration-configuration">
          <h3>Duration Configuration</h3>

          <div class="form__group">
            <label class="form__label">Patient Default Duration</label>
            <p-select
              class="form__dropdown select-box"
              placeholder="Select Duration"
              formControlName="crmClassificaitonduration"
              [options]="classificationDurationOptions"
              appendTo="body"
              filter="true"
            >
            </p-select>
            <div *ngIf="f.crmClassificaitonduration.errors && f.crmClassificaitonduration.touched" class="invalid-feedback">Patient Default Duration is required</div>
          </div>

          <div class="form__group">
            <label class="form__label">Facility Duration</label>
            <p-select
              class="form__dropdown select-box"
              placeholder="Select Duration"
              formControlName="crmFacilityClassificationDuration"
              [options]="classificationDurationOptions"
              appendTo="body"
              filter="true"
            >
            </p-select>
            <div *ngIf="f.crmFacilityClassificationDuration.errors && f.crmFacilityClassificationDuration.touched" class="invalid-feedback">
              Duration for facility is required
            </div>
          </div>

          <div class="form__group">
            <label class="form__label">Remote Duration</label>
            <p-select
              class="form__dropdown select-box"
              placeholder="Select Duration"
              formControlName="crmRemoteClassificationDuration"
              [options]="classificationDurationOptions"
              appendTo="body"
              filter="true"
            >
            </p-select>
            <div *ngIf="f.crmRemoteClassificationDuration.errors && f.crmRemoteClassificationDuration.touched" class="invalid-feedback">
              Duration for remote setup is required
            </div>
          </div>

          <div class="form__group">
            <label class="form__label">Road/home Duration</label>
            <p-select
              class="form__dropdown select-box"
              placeholder="Select Duration"
              formControlName="crmRoadHomeClassificationDuration"
              [options]="classificationDurationOptions"
              appendTo="body"
              filter="true"
            >
            </p-select>
            <div *ngIf="f.crmRoadHomeClassificationDuration.errors && f.crmRoadHomeClassificationDuration.touched" class="invalid-feedback">
              Duration for Road/home visit is required
            </div>
          </div>
        </div>

        <div class="description-configuration">
          <div class="form__group desription-box">
            <label class="form__label">Description</label>
            <textarea class="form__textarea" pInputTextarea formControlName="crmDescription" maxlength="255"></textarea>
            <div *ngIf="f.crmDescription.errors && f.crmDescription.touched" class="invalid-feedback">Description is required</div>
          </div>

          <div class="form__group desription-box">
            <label class="form__label">Classification Documents</label>
            <p-editor formControlName="crmClassificationDocuments" [style]="{height: '200px'}"></p-editor>
          </div>
        </div>
      </div>

      <!-- Blackout day -->
      <div class="classification-popup-outer__right">
        <div class="blackout-day-configuration">
          <h3>Black Out Day(s) Configuration</h3>

          <ng-container formArrayName="blackoutConfig">
            <ng-container *ngFor="let blackoutConfigForm of blackoutConfigs?.controls; let i = index">
              <div class="black-out-days" [formGroup]="blackoutConfigForm">
                <h4>{{ blackoutConfigForm.controls.visitTypeName.value }}</h4>

                <div class="form__group">
                  <label class="form__label">No of Black Out Day(s)</label>
                  <input type="text" formControlName="blackoutDays" class="form__control" pInputText />
                  <div class="invalid-feedback" *ngIf="blackoutConfigForm.controls.blackoutDays.touched">
                    <ng-container *ngIf="blackoutConfigForm.controls.blackoutDays.errors as errors">
                      <div *ngIf="errors.required">
                        BlackOut Days is required.
                      </div>
                      <div *ngIf="!errors.required && errors.max">
                        Please enter value between 0 to 999.
                      </div>
                      <div *ngIf="!errors.required && !errors.max && errors.pattern">
                        Only numbers are allowed.
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div class="form__group status-checkbox">
                  <label class="form__label"></label>
                  <span class="form__checkbox-outer">
                    <p-checkbox binary="true" label="Include Weekend" formControlName="includeWeekend" inputId="includeWeekend"> </p-checkbox>
                    <label class="form__checkbox-label" for="includeWeekend">Include Weekend</label>
                  </span>
                </div>

                <div class="form__group applicable-for">
                  <label class="form__label">Applicable For</label>
                  <div class="radios">
                    <span class="form__radio-outer">
                    <p-radioButton [formControl]="blackoutConfigForm.get('applicableForId')" value="1" label="DME" [name]="i"></p-radioButton>
                    <label class="form__radio-label" for="applicableForId">DME</label>
                    </span>
                    <ng-container *ngIf="blackoutConfigForm.controls.visitTypeId.value !== 3">
                      <span class="form__radio-outer">
                        <p-radioButton [formControl]="blackoutConfigForm.get('applicableForId')" value="2" label="Patients" [name]="i"></p-radioButton>
                        <label class="form__radio-label" for="applicableForId">Patients</label>
                      </span>
                      <span class="form__radio-outer">
                        <p-radioButton [formControl]="blackoutConfigForm.get('applicableForId')" value="3" label="Both" [name]="i"></p-radioButton>
                        <label class="form__radio-label" for="applicableForId">Both</label>
                      </span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="form__group button-box">
    <div class="btns">
      <button class="btn btn--secondary mb-15" (click)="close(false)">Cancel</button>
      <button class="btn btn--primary" (click)="save()">{{ id ? 'Update' : 'Add' }}</button>
    </div>
  </div>

  <div class="loader-block" *ngIf="loading" style="z-index: 10000 !important">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
  </div>
</form>
